export const ultimasNoticias = [
     
    {
        "imagen" : "/assets/imgs/IMG_124.png",
        "url" : "",
        "titulo" : 'Hidalgo Unido',
        "fecha" : "2025"
    },
    {
        "imagen" : "/assets/imgs/IMG_701.png",
        "url" : "https://x.com/Bienestar_Hgo/status/1928521822644863440",
        "titulo" : 'CENTROS DE GERONTOLOGÍA',
        "fecha" : "2025"
    },
    {
        "imagen" : "/assets/imgs/x1.png",
        "url" : "https://spsfa.amigosdelatransformacion.com.mx/",
        "titulo" : 'Padrón Digital Artesanal',
        "fecha" : "2025"
    },
    {
        "imagen" : "/assets/imgs/IMG_123.png",
        "url" : "https://parquecultural.hidalgo.gob.mx/",
        "titulo" : 'Parque Cultural Hidalguense',
        "fecha" : ""
    },
    {
        "imagen" : "/assets/imgs/IMG_605.png",
        "url" : "https://x.com/Bienestar_Hgo/status/1931117685883973868",
        "titulo" : 'Gabinete Social del Estado de Hidalgo',
        "fecha" : "2025"
    },
    
]